/* Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { EMPTY, Observable } from 'rxjs';
import { GamepadService } from './gamepad.service';
import { GamepadButtonName, MonitorOptions } from './gamepad.types';

export class NoOpGamepadService extends GamepadService {
    public get isGamepadConnected$(): Observable<boolean> {
        return EMPTY;
    }
    public get isAnyGamepadInUse$(): Observable<boolean> {
        return EMPTY;
    }
    public get leftPressed$(): Observable<boolean> {
        return EMPTY;
    }
    public get rightPressed$(): Observable<boolean> {
        return EMPTY;
    }
    public get upPressed$(): Observable<boolean> {
        return EMPTY;
    }
    public get downPressed$(): Observable<boolean> {
        return EMPTY;
    }
    public get rightStickMoved$(): Observable<boolean> {
        return EMPTY;
    }
    public onButtonPressed$(button: GamepadButtonName, options?: MonitorOptions): Observable<boolean> {
        return EMPTY;
    }
    public onButtonLongPressed$(button: GamepadButtonName, longPressStartDuration?: number): Observable<boolean> {
        return EMPTY;
    }
    public onButtonComboPressed$(buttons: GamepadButtonName[]): Observable<boolean> {
        return EMPTY;
    }
}
